import React, { useState, useEffect } from "react";
import "../assets/css/colleges.css";
import { Pagination } from "@mui/material";
import SvgContent from "../components/Svgcontent";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Footer from './footer';
import { FaAngleRight } from "react-icons/fa";
import { MutatingDots } from "react-loader-spinner";
import axios from "axios";
import configModule from '../../config.js';
import ApplyNow from "./popups/applynow.jsx";
import Comparison from "./popups/comparison.jsx";
import FilterModal from "./popups/filtermodal.jsx";
import { toast, ToastContainer } from "react-toastify";
import { decode } from "he";

function Colleges() {
  const config = configModule.config();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [likedColleges, setLikedColleges] = useState({});
  const [page, setPage] = useState(1);
  const [colleges, setColleges] = useState([]);
  const [total, setTotal] = useState(0);
  const [showAll, setShowAll] = useState(false);
  const [filterOptions, setFilterOptions] = useState("");
  const [showsFilteredData, setShowsFilteredData] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");

  const [compareOpen, setCompareOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const [courseDetailsFromhome, setCourseDetailsFromhome] = useState((location?.search !== "" ? location.state : {}) || {});
  const [courseCategoryFromhome, setCourseCategoryFromhome] = useState((location?.search === "" && location?.state?.category ? location.state : {}) || {});
  const searchFromhome =
    typeof location.state === "string"
      ? location.state
      : "";

  const [urlFilterParams, setUrlFilterParams] = useSearchParams({});

  const slugify = (name) =>
    name
      ?.split(" ")
      .map(word => {
        if (word.toUpperCase() === word) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join("-");

  useEffect(() => {
    setUrlFilterParams({});
  }, []);

  useEffect(() => {
    if (searchFromhome) {
      setSearch(searchFromhome);
      setPage(1);
    }
  }, [searchFromhome]);

  const getCollegeData = async (pageNumber = 1) => {
    setLoading(true);

    const params = {
      page: pageNumber,
      limit: itemsPerPage,
      ...(sortBy && { sort: sortBy }),
      search: search || "",
      branch_id: filterOptions?.branch_id ? filterOptions?.branch_id : "",
      category_id: filterOptions?.category_id ? filterOptions?.category_id : "",
      state_id: filterOptions?.state_id ? filterOptions?.state_id : "",
      city_id: filterOptions?.city_id ? filterOptions?.city_id : "",
      exam_id: filterOptions?.exam_id ? filterOptions?.exam_id : "",
      course_id: courseDetailsFromhome?.id || -1,
      coursecat_id: courseCategoryFromhome?.id || -1,
      p_acc_app: filterOptions?.application ? filterOptions?.application : -1
    };

    try {
      const res = await axios.get(
        `${config.apiBaseUrl}/get-colleges`, {
        params: params,
        headers: {
          "x-api-key": config?.apichKey
        },
      }
      );

      const { data, total } = res?.data || {};

      setColleges(data || []);
      setTotal(total || 0);

    } catch (err) {
      console.error("API Error:", err);

      if (err.response) {
        toast.error(err.response.data?.message || "Server error");
      } else if (err.request) {
        toast.error("No response from server");
      } else {
        toast.error("Request failed");
      }

    } finally {
      setLoading(false);
    }

  };

  useEffect(() => {
    if (location.state) {
      setCourseDetailsFromhome(
        location?.search !== "" ? location.state : {}
      );

      setCourseCategoryFromhome(
        location?.search === "" ? location.state : {}
      );
    }
  }, [location.state]);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      getCollegeData(page);
    }, 1000);

    return () => clearTimeout(timer);
  }, [
    page,
    sortBy,
    search,
    filterOptions,
    courseDetailsFromhome,
    courseCategoryFromhome,
  ]);

  const itemsPerPage = 9;

  useEffect(() => {
    setPage(1);
  }, [search, sortBy]);


  const filteredColleges = [...colleges].sort((a, b) => {
    if (sortBy === "rating") return b.rating - a.rating;
    if (sortBy === "fees") return a.fees - b.fees;
    return 0;
  });

  const count = Math.ceil(total / itemsPerPage);
  const displayedColleges = filteredColleges.slice(0, itemsPerPage);

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.1;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<SvgContent key={`full-${i}`} svg_name="full_star" width="12" height="12" />);
    }

    if (hasHalfStar) {
      stars.push(<SvgContent key="half-star" svg_name="half_star" width="12" height="12" />);
    }

    const remaining = 5 - stars.length;

    for (let i = 0; i < remaining; i++) {
      stars.push(<SvgContent key={`empty-${i}`} svg_name="star" width="12" height="12" />);
    }

    return stars;
  };

  const onCloseHandler = (sType, sData) => {
    if (sType === "comparison") {
      setCompareOpen(false);
    }
    if (sType === "filter") {
      setFilterOpen(false);
      setFilterOptions(sData);
      const filters = Object.entries(sData)
        .filter(([key]) => key.endsWith("_name"))
        .map(([_, value]) => value.replace(/'/g, ""));
      setShowsFilteredData(filters);

      const params = {};

      if (sData.category_id) params.cou_cat_id = sData.category_id;
      if (sData.state_id) params.state_id = sData.state_id;
      if (sData.branch_id) params.branch_id = sData.branch_id;
      if (sData.city_id) params.city_id = sData.city_id;
      if (sData.exam_id) params.exam_id = sData.exam_id;
      if (sData.application) params.p_acc_app = sData.application;

      setUrlFilterParams(params);
    }
    if (sType === "close") {
      setFilterOpen(false);
    }
    else {
      setOpen(false);
    }
  };

  const clearAllFilters = () => {
    setFilterOptions([]);
    setShowsFilteredData([]);
    setCourseDetailsFromhome({});
    setCourseCategoryFromhome({});
    setUrlFilterParams({});
    navigate("/college_listing");
  };

  useEffect(() => {
    setTimeout(() => {
      document
        .getElementById("college-top")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 50);
  }, [page]);

  const formatCourses = (text, showAll, limit = 20) => {
    if (!text) return "";

    if (showAll || text.length <= limit) return text;

    return text.substring(0, limit) + "...";
  };

  return (
    <div className="mainnav-container" id="college-top">
      <ToastContainer />
      <div className="w-100 h-100" style={{ background: "#F8F8F8" }} >
        {loading && (
          <div className="loader">
            <MutatingDots
              height="100"
              width="100"
              color="#35e2e9"
              secondaryColor="#FF9800"
              radius="15"
              ariaLabel="mutating-dots-loading"
              visible={true}
            />
          </div>
        )}
        <div className="hero-strip d-flex flex-column justify-content-between ">
          <div className="hero-pattern"></div>
          <h1>List of Colleges</h1>
          <p>Explore 7,600+ colleges across India · Compare · Apply for Free</p>
          <span className="breadcrumb-st" > <span className="gotohome-st" onClick={() => navigate("/")} >Home</span> <FaAngleRight className="arrow_icon" /> <b>Colleges</b></span>
        </div>

        <div className="search-float position-relative">
          <div className="position-relative search-inner" >
            <input
              type="text"
              placeholder="Search college..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="search-divider"></div>

            <div className="sortby_wrap">
              <button className="sort-btn" onClick={() => setSortOpen(!sortOpen)}>
                <span className={`sortby_arrow ${sortOpen ? "sortby_rotate" : ""}`}>
                  ⇅
                </span>
                <p className="mb-0 textmbhide-st">Sort By</p>
              </button>

              <ul className={`sortby_menu ${sortOpen ? "sortby_show" : ""}`}>
                <li className="d-center justify-content-start  gap-1" onClick={() => { setSortBy("rating"); setSortOpen(false); }}>
                  <SvgContent svg_name="sortstar" stroke="#00B5B5" width={18} height={18} />
                  <p style={{ color: "rgb(142 145 145)" }}>Rating</p>
                </li>
                <li className="d-center justify-content-start gap-1" onClick={() => { setSortBy("fees"); setSortOpen(false); }}>
                  <SvgContent svg_name="fees" stroke="#00B5B5" width={18} height={18} />
                  <p style={{ color: "rgb(142 145 145)" }}>Fees</p>
                </li>
              </ul>
            </div>

            <button className="compare-btn" onClick={() => setCompareOpen(!compareOpen)}>
              <SvgContent svg_name="compare_icon" stroke="#00B5B5" width={18} height={18} />
              <p className="mb-0 textmbhide-st" >Compare</p>
            </button>

            <button className="filter-btn position-relative" onClick={() => setFilterOpen(!filterOpen)}>
              <SvgContent svg_name="filter" stroke="#fff" width={18} height={18} /> &nbsp;
              <p className="mb-0 textmbhide-st" style={{ color: "#fff" }}>Filter</p>
            </button>

            <div className="searchicon-stcoll"><SvgContent svg_name="search_icon" stroke="#ababab" /></div>
            {/* {search && (<div className="searchcollege-stip" onClick={() => setSearch("")} ><SvgContent svg_name="close" stroke="rgb(239, 87, 87)" width="18" height="18" /></div>)} */}
          </div>
        </div>

        <div className="bodycollg-st">
          <div className="rightsidecoll-st">
            <div className="coll_container">
              <div className="filter-pills">
                <span className="fp-label">Active filters:</span>
                {showsFilteredData &&
                  Object.keys(showsFilteredData).length > 0 ? (
                  Object.entries(showsFilteredData).map(([key, value], idx) => (
                    <div key={idx}>
                      <div className="fp">
                        <i className="ti ti-school"></i>
                        {String(value).replace(/'/g, "")}
                        <i className="ti ti-x"></i>
                      </div>
                    </div>
                  ))
                ) : (
                  <span className="fp-label">No Active filters</span>
                )}

                {(courseDetailsFromhome?.course || courseCategoryFromhome?.category) && (
                  <div className="fp">
                    {courseDetailsFromhome?.course || ""}
                    {courseCategoryFromhome?.category || ""}
                  </div>
                )}


                {(courseDetailsFromhome?.course || courseCategoryFromhome?.category || showsFilteredData.length > 0) && (
                  <button onClick={clearAllFilters} className="fp clear">
                    Clear All Filters
                  </button>
                )}
              </div>
              <p className="results-count">Showing <b>{filteredColleges[0]?.total_count || 0}</b> colleges · Page 1 of {count || 1}</p>


              <div className="colleges-grid">
                {displayedColleges && (
                  <>
                    {displayedColleges.length > 0 ? (displayedColleges.map((college) => (
                      <div className="col-card" key={college.id} onClick={() => {
                        navigate(`/${college.id}/${slugify(decode(college.name))}`, {
                          state: college,
                        });
                      }}>
                        <div className="card-img w-100">
                          <img src={college.college_primary_image} alt={college.name} />
                        </div>

                        <div className="main-card-body">
                          <div className="card-body">
                            <div className="card-rating">
                              {renderStars(college.college_ranking)} <span className="rating-val">({college.college_ranking})</span>
                            </div>
                            <div className="card-name">{decode(college?.name)}</div>
                            <div className="card-info">
                              <div className="card-row">
                                <span className="d-flex"><span style={{ width: "62px", display: "flex" }}>Eligibility:</span> <strong>Entrance</strong></span>
                              </div>
                              <div className="card-row"><span className="d-flex">
                                <span style={{ width: "62px", display: "flex" }}>University:</span> <strong>{college.university}</strong></span>
                              </div>

                              <div className="card-row">
                                <span style={{ width: "62px", display: "flex" }}>Courses:</span> <span className="cclist_value fw-bold">
                                  {formatCourses(college.courses, showAll)}
                                  {college.courses && college.courses.length > 20 && (
                                    <button
                                      onClick={() => setShowAll(!showAll)}
                                      style={{
                                        color: "#b4b4b4",
                                        cursor: "pointer",
                                        border: "none",
                                        background: "none",
                                        marginLeft: "5px"
                                      }}
                                    >
                                      {showAll ? "less" : "more"}
                                    </button>
                                  )}
                                </span></div>
                            </div>
                            <p className="location">📍 {college.city + ", " + college.state + ", " + college.country}</p>
                            <button
                              className={`likebtn_button ${likedColleges[college.id] ? "likebtn_active" : ""
                                }`}
                              onClick={() => {
                                navigate(`/${college.id}/${slugify(decode(college.name))}`, {
                                  state: college,
                                });
                              }}
                              title="wish list"
                            >
                              <SvgContent svg_name="view_btn" />
                            </button>
                          </div>

                          <div className="card-foot">
                            <div className="card-accred"><div className="ca-label">Accreditation</div><div className="ca-val">
                              {college?.naac_approved ? college?.naac_approved : "---"}</div></div>
                            <div className="card-divider"></div>
                            <div className="card-accred"><div className="ca-label">Approved by</div><div className="ca-val aicte">
                              {college?.approved_by ? college?.approved_by : "---"}
                            </div></div>
                            <button className="apply-btn" onClick={() => { setOpen(true); setSelectedItem(college); }} ><i className="ti ti-send"></i> Apply</button>
                          </div>
                        </div>

                      </div>
                    ))) : (
                      <div className="w-100 position-relative flex-column colnoimg-st" >
                        <p>No data found.</p>
                      </div>
                    )}
                  </>)}
              </div>
              <div className="coll_pagination">
                <Pagination
                  count={count}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {open && (
        <ApplyNow data={selectedItem || ""} onCloseHandler={onCloseHandler} />
      )}

      {compareOpen && (
        <Comparison onCloseHandler={onCloseHandler} />
      )}

      {filterOpen && (
        <FilterModal data={filterOptions} onCloseHandler={onCloseHandler} />
      )}

      {!loading && (
        <Footer />
      )}


    </div>
  );
}

export default Colleges;